<template>
  <fb-form-properties-manager id="table-v1-properties-l9vhuz" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "TableV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
